import { useIntl } from 'react-intl';

import { useCarousel } from '../../../design-system/components/carousel/Carousel';
import { Typography } from '../../../design-system/components/typography/Typography';
import { Carousel } from '../../../domains/Layout/Carousel/Carousel';
import { Destination } from '../../../resources/destination/domain/types/destination';
import { UgcHighlight } from '../../../resources/ugcHighlight/domain/types/ugcHighlight';
import { IntrinsicElement } from '../../utilities/types/IntrinsicElement';
import { PickDomain } from '../../utilities/types/PickDomain';

import { UGCHighlightCard } from './UGCHighlightCard/UGCHighlightCard';

import style from './UGCHighlightSection.module.css';

type UGCHighlightSectionProps = {
    ugcHighlights: Array<
        PickDomain<
            UgcHighlight,
            'id' | 'username' | 'segment' | 'validatedAt' | 'description' | 'pictures'
        >
    >;
    destination: PickDomain<Destination, 'id' | 'slug'>;
    subTitleElement?: IntrinsicElement;
};

export function UGCHighlightSection({
    ugcHighlights,
    destination,
    subTitleElement,
}: UGCHighlightSectionProps) {
    const { formatMessage } = useIntl();
    const carouselProps = useCarousel();

    return (
        <div className={style.container}>
            <div className={style.titleWrapper}>
                <Typography scale="secondary-m-bold">
                    {formatMessage({ id: 'global.ugc.title' })}
                </Typography>
                <Typography
                    as={subTitleElement}
                    className={style.subtitle}
                    scale="primary-s-extra-bold"
                >
                    {formatMessage({ id: 'global.ugc.subtitle' })}
                </Typography>
            </div>
            <div>
                <Carousel
                    {...carouselProps}
                    slidesSize="large"
                    slidesVisibleRules={{
                        sm: 2,
                        md: 2,
                        lg: 2,
                        xl: 2,
                        xxl: 2,
                    }}
                >
                    {ugcHighlights.map((ugcHighlight, index) => (
                        <UGCHighlightCard
                            key={ugcHighlight.id}
                            ugcHighlight={ugcHighlight}
                            index={index}
                            destination={destination}
                        />
                    ))}
                </Carousel>
            </div>
        </div>
    );
}
